{
    "ChannelCode": "編號",
    "Components": {
        "MeetingEnd": {
            "FeedbackConfirmation": {
                "ExploreMoreFeatures": "探索更多功能",
                "ThanksMessage": "感謝您的參與，",
                "WorkingMessage": "希望翻譯為您帶來更好的活動體驗。"
            },
            "FeedbackForm": {
                "FeedbackQuestion": "翻譯品質如何？",
                "SessionClosedMessage": "即時翻譯現已結束。",
                "ThankYouMessage": "希望這次服務對您有所幫助！"
            }
        }
    },
    "Continue": "繼續",
    "Control": {
        "Original": "原文",
        "Spacing": "段距",
        "TextSize": "字級",
        "Tts": "TTS"
    },
    "Download": "下載",
    "Idle": "閒置",
    "Join": "加入",
    "LanguageSettings": "語言",
    "Live": "進行中",
    "Loading": {
        "Entering": "正在進入頻道",
        "Joining": "正在加入頻道"
    },
    "OK": "確定",
    "Pages": {
        "Home": {
            "EnterEventCodeMessage": "請輸入頻道代碼。",
            "InputPlaceholder": "輸入頻道代碼",
            "Title": "在場，就能聽懂一切"
        },
        "SelectLanguage": {
            "SearchEmpty": "找不到符合的語言",
            "SearchPlaceholder": "搜尋語言",
            "Title": "選擇翻譯語言"
        }
    },
    "Pane": {
        "CatchUp": "跳到最新",
        "Source": "原文",
        "Translation": "譯文",
        "Tts": "語音朗讀",
        "TtsShort": "TTS"
    },
    "Share": "分享",
    "SpeechSpeed": "語速",
    "Start": "開始",
    "Submit": "送出",
    "Tips": {
        "Error": {
            "Channel": {
                "LimitExceeded": "頻道已達同時連線上限，無法進入。"
            }
        },
        "Icon": {
            "ScrollToBottom": "回到最新",
            "ShareLink": "分享連結",
            "SpeechRate": "調整語音速度"
        }
    },
    "Toast": {
        "LanguageChanged": "翻譯語言已切換為 {lang}",
        "LinkCopied": "連結已複製",
        "SourceOff": "已隱藏原文",
        "SourceOn": "已顯示原文",
        "TtsOff": "語音朗讀已關閉",
        "TtsOn": "語音朗讀已開啟"
    },
    "Transcript": {
        "Start": "以上沒有更多內容"
    },
    "tutorialPage": {
        "downloadOverlay": {
            "originText": "原始文本",
            "summary": "摘要",
            "transcript": "文字稿"
        },
        "translationLanguage": {
            "title": "翻譯語言"
        }
    }
}
